import { LoyaltyProgram } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import prefix from '../prefix';
import parentSelector from '../selector';
import { createBaseEntitySelectors, createEntitiesReducer } from './utils';

export const NAME = 'loyaltyPrograms';

export const setLoyaltyPrograms = (entities: Array<LoyaltyProgram>) =>
    createAction(LOYALTY_PROGRAMS_LOADED, { entities });

export const [getLoyaltyPrograms, getLoyaltyProgramsByIds, getLoyaltyProgramsByOwnerId, getLoyaltyProgram] =
    createBaseEntitySelectors<ApplicationState, LoyaltyProgram, typeof NAME>(parentSelector, NAME);

export const LOYALTY_PROGRAMS_LOADED = prefix('LOYALTY_PROGRAMS_LOADED');

export default createEntitiesReducer({
    FETCH_SUCCESS: LOYALTY_PROGRAMS_LOADED,
});
